import queries, { excelQueries, ssQueries } from "@/queries";
import { useQueryClient } from "@tanstack/react-query";
import { useWorkbookId } from "./use-workbook";

export default function useClearQueryCache() {
  const queryClient = useQueryClient();
  const { data: workbookId } = useWorkbookId();

  return () => {
    if (!workbookId) return;
    queryClient.removeQueries({
      queryKey: queries.workbook(workbookId)._ctx.tables._def,
    });
    queryClient.removeQueries({
      queryKey: ssQueries._def,
    });
    queryClient.removeQueries({
      queryKey: excelQueries._def,
    });
  };
}
